import { createFileRoute } from "@tanstack/react-router";

import { ConnectionsSettingsPage } from "../components/settings/ConnectionsSettingsPage";

export const Route = createFileRoute("/settings/environments")({
  component: ConnectionsSettingsPage,
});
